/**
 * @classdesc Dados do usuário para identificação nas ferramentas de APM.
 */
export default class ApmUser {
    id;
    localizacao;
    username;
    nome;
}
